import script from "./PageNation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageNation.vue?vue&type=script&setup=true&lang=ts"

import "./PageNation.vue?vue&type=style&index=0&id=5a8fd4c9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8fd4c9"]])

export default __exports__